module.exports = __webpack_public_path__ + "17aeab48a1074d1e504f99b119beff83.pdf";